import { render, staticRenderFns } from "./check-24.vue?vue&type=template&id=37c11ee4&scoped=true"
import script from "./check-24.vue?vue&type=script&lang=js"
export * from "./check-24.vue?vue&type=script&lang=js"
import style0 from "./check-24.vue?vue&type=style&index=0&id=37c11ee4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c11ee4",
  null
  
)

export default component.exports